import React, { Component } from 'react';
import { Languages } from './Languages.js';
class LanguageDropdown extends Component {

    state = {
        value: this.props.value == null ? 0 : this.props.value,
        onChange: this.props.onChange
    };

    handleOnChange = (event) => {
        this.setState({ value: event.target.selectedIndex });
        this.state.onChange(event);
    };

    render() {
        let LanguageList = this.props.LanguageList ? this.props.LanguageList : Languages;
        return (
            <select className="btn btn-default" onChange={this.handleOnChange} data-value={this.state.value}>
                {LanguageList.map(item => <option key={item.id} value={item.code}>{item.name}</option>)}
            </select>
        );
    }
}

export default LanguageDropdown;
